(function () {
    'use strict';
    angular.module('Directives').directive('bbaModulesUserAccessPermissions', bbaModulesUserAccessPermissions);
    bbaModulesUserAccessPermissions.$inject = [
        'FleetService',
        'Carrier'
    ];

    function bbaModulesUserAccessPermissions(FleetService, Carrier) {
        return {
            restrict: 'E',
            replace: true,
            require: '^form',
            templateUrl: '/templates/directives/components/administration/bba-modules-user-access-permissions.html',
            scope: {
                ngModel: '='
            },
            link: bbaModulesUserAccessPermissionsLink
        }

        function bbaModulesUserAccessPermissionsLink($scope) {
            const reportingShipmentsPermissionsNames = [
                'Shipments',
                'Clients',
                'Reporting',
                'Accounts By Spend',
                'Manifests'
            ];
            const carrierManagementPermissionNames = [
                'Carriers',
                'Margins',
                'Billing',
                'BBA Mastro Billing',
                'BBA Profile Manager',
                'Invoicing',
                'Hide Rates Engine'
            ];
            const fleetManagementPermissionNames = [
                'Job Mapping',
                'Fleet Management',
                'Cross Dock',
                'Area and Route'
            ];

            $scope.permissionsGroups = [];
            $scope.isAllSelected = false;

            $scope.selectAll = selectAll;
            $scope.carrierSelected = carrierSelected;
            $scope.areaSelected = selected;
            $scope.listArea = [];
            $scope.listOfCarriers = [];
            init();

            function init() {
                getUsersAreas();
                setNgModelWatcher();

            }

            function setNgModelWatcher() {
                groupPermissions();
                getAreasAndRoute();
                getCarrierProfile();
                $scope.$watch('ngModel', (data) => {
                    if (!data) { return; }
                    setIsSelectedDefaultValue();
                }, true);
            }

            function getAreasAndRoute() {
                FleetService.Areas.getAll(
                    success => {
                        const list = []
                        success.content.forEach(item => {
                            list.push({
                                areaId: item.id,
                                areaName: item.areaId,
                                active: true
                            })
                        })
                        $scope.listArea = list;
                    }, error => {
                        console.log(error);
                    }, { size: 50 })
            }

            function getCarrierProfile() {
                Carrier.getCarriers(function (data) {
                    $scope.listOfCarriers = data
                }, function (err) {
                    console.log(err);
                });
            }

            function carrierSelected() {
                angular.forEach($scope.ngModel, (item) => {
                    if (item.id === 8) {
                        if (!item.selectedCarrier.length) {
                            $scope.listOfCarrier = $scope.carrierList;
                            return
                        }
                    }
                })
            }

            function selected() {

                angular.forEach($scope.ngModel, (item) => {
                    if (item.id === 18) {
                        if (!item.selectedAreas.length) {
                            $scope.listArea = $scope.areaList;
                            return
                        }
                    }

                })
            }

            function groupPermissions() {
                getReportingShipmentsPermissions();
                getCarrierManagementPermissions();
                getFleetManagementPermissions();
                getAdditionalPermissions();
            }

            function setIsSelectedDefaultValue() {
                $scope.isAllSelected = checkIfAllPermissionIsActive();
            }

            function checkIfAllPermissionIsActive() {
                const inActivePermissions = $scope.ngModel.filter(permission => !permission.active);
                return inActivePermissions.length < 1;
            }

            function getReportingShipmentsPermissions() {

                const reportingShipmentsPermissions = $scope.ngModel
                    .filter(data => reportingShipmentsPermissionsNames.find(name => name === data.name)
                    );

                $scope.permissionsGroups.push({
                    name: 'Shipment Reporting Permissions',
                    permissions: reportingShipmentsPermissions
                });
            }

            function getCarrierManagementPermissions() {
                const carrierManagementPermissions = $scope.ngModel
                    .filter(data => carrierManagementPermissionNames.find(name => name === data.name));
                $scope.permissionsGroups.push({
                    name: 'Carrier Management Permissions',
                    permissions: carrierManagementPermissions
                });
            }

            function getAvailableOptions(current) {
                console.log(current)
            }

            function getUsersAreas() {
                angular.forEach($scope.ngModel, (item) => {
                    if (item.id === 18) {
                        angular.forEach(item.selectedAreas, data => {
                            data.active = true
                        });
                    }
                })
            }

            function getFleetManagementPermissions() {
                const fleetManagementPermissions = $scope.ngModel
                    .filter(data => fleetManagementPermissionNames.find(name => name === data.name));
                $scope.permissionsGroups.push({
                    name: 'Fleet Management Permissions',
                    permissions: fleetManagementPermissions
                })
            }

            function getAdditionalPermissions() {
                const additionalPermissions = $scope.ngModel.filter(data => {
                    const foundInReporting = reportingShipmentsPermissionsNames.find(name => name === data.name);
                    const foundInCarrierManagement = carrierManagementPermissionNames.find(name => name === data.name);
                    const foundInFleetManagement = fleetManagementPermissionNames.find(name => name === data.name);

                    if (!foundInReporting && !foundInCarrierManagement && !foundInFleetManagement) {
                        return data;
                    }
                });

                $scope.permissionsGroups.push({
                    name: 'Additional Permissions',
                    permissions: additionalPermissions
                });
            }

            function selectAll(isSelectAll) {
                $scope.ngModel.forEach(data => {
                    data.active = isSelectAll;
                });
            }
        }
    }
})()



// WEBPACK FOOTER //
// ./js/directives/component/administration/bba-modules-user-access-permissions.js